export const domain = 'avalancheca.auth0.com'
export const clientId = process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID
export const audience = 'api.avalanche.ca'
